/**
 * validate a form with al the validations for each field
 * #TODO: not implemented yet
 */
function validateForm() {}

module.exports = { validateForm };
